import { Component } from "@angular/core";

@Component({
  templateUrl: './club-package.component.html'
})
export class ClubPackageComponent {

  constructor() {
  }


}
